<script setup lang="ts">
import { damageColors } from "../ui/damageColors";
import { Pet } from '../core/pet';

defineProps<{
    pos: 'left' | 'right',
    pet: Pet,
    criticalStrike?: boolean,
}>();
</script>

<template>
    <p :class="pos">
        <span class="attack-immune" v-if="pet.战斗面板.attackImmune">免疫攻击</span>
        <span class="not-hit" v-if="pet.战斗面板.notHit">MISS</span>
        <span class="recover" v-if="pet.战斗面板.recoverHP">+{{ pet.战斗面板.recoverHP }}</span>
        <span class="critical-damage" :style="{ color: damageColors[0] }" v-if="pet.战斗面板.damage !== undefined && criticalStrike">
            -{{ pet.战斗面板.damage }}
        </span>
        <span class="damage" v-else-if="pet.战斗面板.damage !== undefined">-{{ pet.战斗面板.damage }}</span>
        <span class="fixed-damage" :style="{ color: damageColors[1] }" v-if="pet.战斗面板.fixedDamage">-{{ pet.战斗面板.fixedDamage }}</span>
        <span class="percent-damage" :style="{ color: damageColors[2] }" v-if="pet.战斗面板.percentDamage">-{{ pet.战斗面板.percentDamage }}</span>
        <span class="hp-loss" v-if="pet.战斗面板.hpLoss">-{{ pet.战斗面板.hpLoss }}</span>
    </p>
</template>

<style scoped>
p {
    margin: 0;
    font-size: calc(var(--ui-unit) * 36);
    line-height: 1;
}

p span {
    padding: 0.25em;
}

span.hp-loss {
    color: #7c3aed;
}

span.recover {
    color: forestgreen;
}



span.not-hit {
    color: deepskyblue;
}

span.attack-immune {
    color: deepskyblue;
}

</style>
